import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["header", "type"];
import React from 'react';
import SpecialVariant from './Special.variant';
import { MenuCategoryPropType, MenuItemPropType } from '../../services/proptypes';
import './Special.css';
var Specials = function Specials(props) {
  var header = props.header,
    type = props.type,
    rest = _objectWithoutProperties(props, _excluded);
  var Special = SpecialVariant[type];
  return /*#__PURE__*/React.createElement(React.Fragment, null, header, /*#__PURE__*/React.createElement(Special, rest));
};
Specials.defaultProps = {
  categories: [],
  header: /*#__PURE__*/React.createElement("h1", null, "Specials"),
  type: 'default',
  autoScroll: true,
  groupByCategory: false,
  precision: 2
};
export default Specials;